<template>
  <v-app>
    <v-app-bar app color="white" elevation="0">
      <v-img
        class="shrink mr-2"
        contain
        src="../assets/logo.png"
        transition="scale-transition"
        width="40"
      />
      {{$t('label.veriscan') }}
    </v-app-bar>

    <v-container fill-height fluid v-if="this.error">
      <v-row>
        <v-col align="center" justify="center">
          <v-icon size="100">sentiment_very_dissatisfied</v-icon>
          <br />
          <p
            class="title grey--text text--darken-3"
          >Sorry, something has gone wrong and we're unable to register you at this time. Please try again shortly.</p>
        </v-col>
      </v-row>
    </v-container>

    <v-main>
      <v-progress-linear v-if="this.pricesLoading" indeterminate height="2" />
      <GlobalAlert :globalAlert="alert" />

      <v-container fluid v-if="!this.error && !this.pricesLoading">
        <v-stepper v-model="step" class="noBorder">
          <v-stepper-items>
            <!--prices -->
            <v-stepper-content step="1">
              <v-sheet dark>
                <v-img
                  src="../assets/reg-banner.jpg"
                  aspect-ratio="10"
                  gradient="to top right, rgba(100,115,201,.8), rgba(25,32,72,1)"
                >
                  <v-container fluid>
                    <v-row justify="center">
                      <v-col>
                        <p class="heroText">Unlock your operational efficiency</p>

                        <p>Flexible pricing plans to meeting your organizations needs</p>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-img>
              </v-sheet>

              <v-row>
                <v-col v-for="price in getPrices(true)" :key="price.id" sm="12" md="3" lg="3">
                  <v-card min-height="450" outlined tile>
                    <v-card-text>
                      <h2 class="pb-5">{{price.title}}</h2>
                      <v-sheet min-height="100">{{price.description}}</v-sheet>

                      <span class="display-2 pb-10">${{price.rate}}</span>
                      USD / month
                      <v-sheet height="4" width="25" color="primary" tile class="mb-5 mt-2" />
                      <v-sheet height="150">
                        <v-row>
                          <v-col>
                            <div class="overline primary--text">Tier Limit</div>
                            <b>{{price.searchLimit}}</b> Searches / month
                            <br />
                            <b>{{price.userLimit}}</b> Users
                            <br />
                            <b>${{price.additionalSearch}}</b> Per additional search
                            <br />
                            <b>{{price.support}}</b>
                          </v-col>
                        </v-row>
                      </v-sheet>
                    </v-card-text>
                    <v-card-actions>
                      <v-row justify="center">
                        <v-btn tile color="primary" @click="submitPrice(price.id)">Get Started</v-btn>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-stepper-content>

            <!-- organization -->
            <v-stepper-content step="2">
              <v-card class="noBorder" outlined>
                <v-card-text>
                  <v-row>
                    <v-col class="d-none d-lg-flex">
                      <v-img
                        dark
                        src="../assets/building.jpg"
                        gradient="to top right, rgba(100,115,201,.4), rgba(25,32,72,1)"
                      ></v-img>
                    </v-col>
                    <v-col>
                      <v-form ref="orgForm">
                        <v-row>
                          <v-col>
                            <v-text-field
                              v-model="req.organization"
                              label="Organization"
                              :rules="[rules.required]"
                            />
                            <v-text-field
                              v-model="req.phone"
                              label="phone"
                              :rules="[rules.required]"
                            />
                            <v-text-field
                              v-model="req.address"
                              label="address"
                              :rules="[rules.required]"
                            />
                          </v-col>
                          <v-col>
                            <v-text-field
                              v-model="req.city"
                              label="city"
                              :rules="[rules.required]"
                            />
                            <v-text-field
                              v-model="req.state"
                              label="state"
                              :rules="[rules.required]"
                            />
                            <v-text-field v-model="req.zip" label="zip" :rules="[rules.required]" />
                            <v-text-field
                              v-model="req.country"
                              label="country"
                              :rules="[rules.required]"
                            />
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="step = step - 1" tile>Back</v-btn>
                  <v-btn color="primary" @click="submitOrg()" tile>Next</v-btn>
                </v-card-actions>
              </v-card>

              <!-- <v-row>
                <v-col class="d-none d-lg-flex">
                  <v-img
                    dark
                    src="../assets/building.jpg"
                    gradient="to top right, rgba(100,115,201,.4), rgba(25,32,72,1)"
                  ></v-img>
                </v-col>
                <v-col>
                  <v-card class="noBorder" outlined>
                    <v-card-text>
                      <v-form ref="orgForm">
                        <v-row>
                          <v-col>
                            <v-text-field
                              v-model="req.organization"
                              label="Organization"
                              :rules="[rules.required]"
                            />
                            <v-text-field
                              v-model="req.phone"
                              label="phone"
                              :rules="[rules.required]"
                            />
                            <v-text-field
                              v-model="req.address"
                              label="address"
                              :rules="[rules.required]"
                            />
                          </v-col>
                          <v-col>
                            <v-text-field
                              v-model="req.city"
                              label="city"
                              :rules="[rules.required]"
                            />
                            <v-text-field
                              v-model="req.state"
                              label="state"
                              :rules="[rules.required]"
                            />
                            <v-text-field v-model="req.zip" label="zip" :rules="[rules.required]" />
                            <v-text-field
                              v-model="req.country"
                              label="country"
                              :rules="[rules.required]"
                            />
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="primary" @click="step = step - 1">Back</v-btn>
                      <v-btn color="primary" @click="submitOrg()">Next</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>-->
            </v-stepper-content>

            <!-- user + payment -->
            <v-stepper-content step="3">
              <v-row>
                <v-col cols="6">Graphic on organization</v-col>
                <v-col cols="6">
                  <v-form ref="userForm">
                    <v-row>
                      <v-col>
                        <v-text-field v-model="req.name" label="name" :rules="[rules.required]" />
                      </v-col>
                      <v-col>
                        <v-text-field v-model="req.title" label="title" :rules="[rules.required]" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="req.email"
                          label="email"
                          :rules="[rules.required, rules.email]"
                          :error="emailError"
                          :error-messages="emailErrorMessage"
                          validate-on-blur
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="req.password"
                          label="password"
                          type="password"
                          :rules="[rules.required]"
                          validate-on-blur
                        />
                      </v-col>
                      <v-col>
                        <v-text-field
                          label="confirm"
                          type="password"
                          :rules="[rules.required, rules.confirmPassword] "
                          validate-on-blur
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="'trial' !== req.price">
                      <v-col>
                        <!-- card -->
                        <card
                          class="stripeCard"
                          :class="{ cardComplete, inputError: cardErrorMessage}"
                          :stripe="getStripePK"
                          @change="cardChanged($event)"
                          :options="this.stripeOptions"
                        />
                        <p class="cardError" v-if="this.cardErrorMessage">{{cardErrorMessage}}</p>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="step = step - 1">Previous</v-btn>
                <v-btn color="primary" @click="register()" :disabled="loading">Register</v-btn>
              </v-card-actions>
            </v-stepper-content>

            <!-- success -->
            <v-stepper-content step="4">
              <v-row>
                <v-col align="center" justify="center">
                  <v-icon color="green" size="75">fa-thumbs-up</v-icon>
                </v-col>
              </v-row>
              <v-row>
                <v-col align="center" justify="center">
                  <p
                    class="headline grey--text text--darken-3"
                  >Welcome! You are all set to begin VeriScan.</p>
                  <p
                    class="title font-weight-light"
                  >We've sent an email with instructions on getting started.</p>

                  <v-card class="noBorder" color="grey lighten-4" width="600">
                    <v-row>
                      <v-col>
                        <span class="font-weight-medium">Username</span>
                        {{req.email}}
                        <br />
                        <span v-if="receiptUrl">
                          <span class="font-weight-medium">Receipt</span>
                          <a :href="receiptUrl" target="_blank">Click here</a>
                        </span>
                        <div v-if="!receiptUrl">
                          <span class="font-weight-medium">Trial period</span> 14 days
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>

                  <v-row class="pt-5">
                    <v-col>
                      <v-btn
                        color="primary"
                        type="submit"
                        to="/login"
                      >{{ $t('view.login.button.login') }}</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import GlobalAlert from "../components/GlobalAlert";
import { Card, createToken } from "vue-stripe-elements-plus";
export default {
  name: "Register",
  created() {
    this.loadWebConfig()
      .catch(() => {
        this.error = true;
        console.error("Error loading web config");
      })
      .finally(() => {
        this.pricesLoading = false;
      });
  },
  components: { GlobalAlert, Card },
  computed: {
    ...mapGetters(["getPrices", "getStripePK"])
  },
  data() {
    return {
      error: false,
      emailError: false,
      loading: false,
      pricesLoading: true,
      cardComplete: false,
      cardErrorMessage: "",
      emailErrorMessage: "",
      receiptUrl: "",
      step: 1,
      req: {},
      alert: {
        alert: false,
        alertTitle: "",
        alertMessage: ""
      },
      rules: {
        required: value => !!value || "Required",
        confirmPassword: value =>
          value === this.req.password || "Passwords do not match",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail";
        }
      },
      stripeOptions: {
        style: {
          base: {
            border: "black",
            color: "rgba(0, 0, 0, 0.54)",
            fontFamily: '"Roboto", sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
              color: "rgba(0, 0, 0, 0.54)"
            }
          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
            fontFamily: '"Roboto", sans-serif'
          }
        }
      }
    };
  },
  methods: {
    ...mapActions(["loadWebConfig"]),
    cardChanged(event) {
      if (event.error) {
        this.cardErrorMessage = event.error.message;
        this.cardComplete = false;
      } else {
        this.cardErrorMessage = null;
        this.cardComplete = true;
      }
    },
    submitPrice(priceId) {
      this.req.price = priceId;
      this.step = this.step + 1;
    },
    submitOrg() {
      if (!this.$refs.orgForm.validate()) {
        return false;
      }
      this.step = this.step + 1;
    },
    register() {
      this.resetErrors();

      if (this.$refs.userForm.validate()) {
        if (this.req.price !== "trial") {
          if (this.cardComplete) {
            this.loading = true;
            createToken()
              .then(data => {
                this.req.cardToken = data.token.id;
                this.postReq();
              })
              .catch(() => {
                this.alert.alertMessage = this.$t(
                  "view.register.error.creditCard"
                );
                this.alert.alert = true;
                this.loading = false;
                return;
              });
          } else {
            if (!this.cardErrorMessage) {
              this.cardErrorMessage = "Please enter a payment method";
              return;
            }
          }
        } else {
          this.loading = true;
          this.postReq();
        }
      }
    },
    postReq() {
      axios({ url: "register", data: this.req, method: "POST" })
        .then(response => {
          this.receiptUrl = response.data.receiptUrl;
          this.step = this.step + 1;
        })
        .catch(error => {
          if (error.response.data.code == 2) {
            this.emailError = true;
            this.emailErrorMessage = this.$t("error.register.emailExists");
          } else {
            this.alert.alertMessage = this.$t("error.general.unhandled");
            this.alert.alert = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetErrors() {
      //this.cardErrorMessage = null
      this.alert.alert = false;
      this.alert.alertMessage = "";
      this.emailError = false;
      this.emailErrorMessage = "";
    }
  }
};
</script>

<style>
.noBorder {
  box-shadow: none;
  border-color: white !important;
}
.cardError {
  color: red;
  line-height: 20px;
  font-size: 12px;
}
.stripeCard {
  border-style: solid;
  padding: 5px;
  border-width: 0 0 1px;
  border-color: rgba(0, 0, 0, 0.4);
}
.inputError {
  border-color: red !important;
}
.gradBanner {
  background: rgb(29, 67, 253);
  background: linear-gradient(
    0deg,
    rgba(29, 67, 253, 0.8603816526610644) 20%,
    rgba(47, 29, 253, 1) 100%
  );
}

.heroText {
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: 200;
  font-size: 35px;
}
.v-toolbar__extension {
  padding: 0px !important;
}
</style>


